import { makeRoute } from "@/lib/makeRoute";

export const Route = makeRoute("/en/tools", "en", "tools");
